// Shared Terms of Service / Privacy Policy disclosure shown wherever someone starts, creates an account, or subscribes.
const Link = ({ href, children, testId }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className="font-medium text-slate-700 underline underline-offset-2 hover:text-teal-700">{children}</a>
);

export const LegalNotice = ({ action = "continuing", testId = "legal-notice", className = "" }) => (
  <p className={`text-center text-xs leading-relaxed text-slate-500 ${className}`} data-testid={testId}>
    By {action}, you acknowledge that you have read and agree to our <Link href="https://getfionova.com/terms" testId={`${testId}-terms`}>Terms of Service</Link> and
    acknowledge our <Link href="https://getfionova.com/privacy" testId={`${testId}-privacy`}>Privacy Policy</Link>.
  </p>
);
